import { createContext, useContext, useState, useCallback } from 'react';

const CompareContext = createContext(null);

const MAX_COMPARE_ITEMS = 3;

export const CompareProvider = ({ children }) => {
  const [compareList, setCompareList] = useState([]);

  const addToCompare = useCallback((provider) => {
    setCompareList((prev) => {
      // Check if already in list
      if (prev.find(p => p.number === provider.number)) {
        return prev;
      }
      // Check max limit
      if (prev.length >= MAX_COMPARE_ITEMS) {
        return prev;
      }
      return [...prev, provider];
    });
  }, []);

  const removeFromCompare = useCallback((npi) => {
    setCompareList((prev) => prev.filter(p => p.number !== npi));
  }, []);

  const isInCompare = useCallback((npi) => {
    return compareList.some(p => p.number === npi);
  }, [compareList]);

  const clearCompare = useCallback(() => {
    setCompareList([]);
  }, []);

  const canAddMore = compareList.length < MAX_COMPARE_ITEMS;

  return (
    <CompareContext.Provider value={{
      compareList,
      addToCompare,
      removeFromCompare,
      isInCompare,
      clearCompare,
      canAddMore,
      maxItems: MAX_COMPARE_ITEMS
    }}>
      {children}
    </CompareContext.Provider>
  );
};

export const useCompare = () => {
  const context = useContext(CompareContext);
  if (!context) {
    throw new Error('useCompare must be used within a CompareProvider');
  }
  return context;
};
